<!--    @if (notification() && success()) {-->
<!--        <notification [message]="success()" type="success" />-->
<!--    }-->
<!--    @if (notification() && error()) {-->
<!--        <notification [message]="error()" type="error" />-->
<!--    }-->

<!--<div id="NotificationContainer">-->
<!--    @if (dialogsService.showNotification()) {-->
<!--        @let status = dialogsService._statusNotification();-->
<!--        <notification [message]="status.message" [type]="status.status"></notification>-->
<!--    }-->
<!--</div>-->

<div class="content">
    <div class="panel">
        <h2 class="pb-0">Dialog/Popup verwalten</h2>
        @if (dialogsService.isLoading()) {
            <phx-table-skeleton [rows]="15" [columns]="4"></phx-table-skeleton>
        } @else {
            <div class="filter-row mt-l">
<!--                <mat-form-field appearance="outline">-->
<!--                    <mat-label>Position</mat-label>-->
<!--                    <mat-select [value]="location()" (selectionChange)="onLocationChange($event.value)">-->
<!--                        <mat-option value="">Alle</mat-option>-->

<!--                        @for (loc of locations(); track loc.value) {-->
<!--                            <mat-option [value]="loc.value">-->
<!--                                {{ loc.label }}-->
<!--                            </mat-option>-->
<!--                        }-->
<!--                    </mat-select>-->
<!--                </mat-form-field>-->
                <mat-form-field appearance="outline">
                    <mat-label>Status</mat-label>
                    <mat-select [value]="status()" (selectionChange)="onStatusChange($event.value)">
                        <mat-option value="ALL">Alle</mat-option>
                        <mat-option value="ACTIVE">Aktiv</mat-option>
                        <mat-option value="PENDING">Ausstehend</mat-option>
                        <mat-option value="INACTIVE">Beendet</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Portal</mat-label>
                    <mat-select [value]="company()" (selectionChange)="onCompanyChange($event.value)">
                        <mat-option value="">Alle</mat-option>
                        <mat-option value="PHOENIX">Phoenix AP</mat-option>
                        <mat-option value="HAGEDA">Hageda AP</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-60">
                    <mat-label>Titel filter</mat-label>
                    <input matInput
                           [value]="inputFilter()"
                           (input)="onInputChange($event)"
                           (keyup.enter)="triggerSearch()"
                           placeholder="Titel suchen">
                    @if (inputFilter()) {
                        <a matSuffix aria-label="Clear" (click)="clearFilter()" class="pr-xs">
                            <mat-icon>close</mat-icon>
                        </a>
                    }
                </mat-form-field>
                <button (click)="resetFilter()"
                        class="btn phx-cta d-inline-flex align-items-center justify-content-center">
                    <mat-icon>close</mat-icon> <span>Filter zurücksetzen</span>
                </button>

            </div>

            <div class="table-tools">
                <button (click)="createDialog()" class="btn-primary mt-0">+ Neuen Dialog erstellen</button>

                <mat-paginator
                        [length]="totalElements()"
                        [pageSize]="size()"
                        [pageIndex]="page()"
                        [pageSizeOptions]="[5, 10, 20, 50, 100]"
                        (page)="handlePageEvent($event)"
                        showFirstLastButtons>
                </mat-paginator>
            </div>

            <div class="table-container">
                <table mat-table
                       [dataSource]="tableData()"
                       class="table-status"
                       (matSortChange)="handleSortChange($event)"
                       matSort
                       [matSortActive]="sorting().field"
                       [matSortDirection]="sorting().direction">
                    <!-- Status Column -->
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef> Status</th>
                        <td mat-cell *matCellDef="let element" class="table-status">
                            <mat-icon fontSet="material-symbols-outlined" aria-hidden="false"
                                      class="{{element.status}} filled-icon">circle
                            </mat-icon>
                        </td>
                    </ng-container>

                    <!-- Title Column -->
                    <ng-container matColumnDef="title">
                        <th mat-header-cell *matHeaderCellDef> Titel</th>
                        <td mat-cell *matCellDef="let element"> {{ element.title }}</td>
                    </ng-container>

                    <!-- Link Column -->
<!--                    <ng-container matColumnDef="link">-->
<!--                        <th mat-header-cell *matHeaderCellDef> Link</th>-->
<!--                        <td mat-cell *matCellDef="let element">-->
<!--                            @if (element.link) {-->
<!--                                <a href="{{ element.link }}" target="_blank" matTooltip="{{ element.link }}">-->
<!--                                    <mat-icon fontSet="material-symbols-outlined" aria-hidden="false">link</mat-icon>-->
<!--                                </a>-->
<!--                            } @else {-->
<!--                                <mat-icon fontSet="material-symbols-outlined" aria-hidden="false">link_off</mat-icon>-->
<!--                            }-->

<!--                        </td>-->
<!--                    </ng-container>-->

                    <!-- Image Column -->
<!--                    <ng-container matColumnDef="image">-->
<!--                        <th mat-header-cell *matHeaderCellDef> Bild</th>-->
<!--                        <td mat-cell *matCellDef="let element">-->
<!--                            <mat-icon-->
<!--                                    fontSet="material-symbols-outlined"-->
<!--                                    aria-hidden="false"-->
<!--                                    class="cursorPointer"-->
<!--                                    (click)="showImagePreview(element.imagePath)">image-->
<!--                            </mat-icon>-->
<!--                        </td>-->
<!--                    </ng-container>-->

                    <!-- Date Column -->
                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef> Datum</th>
                        <td mat-cell *matCellDef="let element"> {{ element.start }} - {{ element.end }}</td>
                    </ng-container>


                    <!-- Order Column -->
<!--                    <ng-container matColumnDef="location">-->
<!--                        <th mat-header-cell *matHeaderCellDef> Position</th>-->
<!--                        <td mat-cell *matCellDef="let element"> {{ element.location | adsLocations }}</td>-->
<!--                    </ng-container>-->

                    <!-- Portal Column -->
                    <ng-container matColumnDef="portal">
                        <th mat-header-cell *matHeaderCellDef> Portal</th>
                        <td mat-cell *matCellDef="let element">
                            @if (element.onPhoenix) {
                                <img src="assets/img/logo/phoenix-logo_corp.svg" alt="" class="table-logo mr-xs">
                            }
                            @if (element.onHageda) {
                                <img src="assets/img/logo/hageda-stumpf-logo.svg" alt="" class="table-logo">
                            }
                        </td>
                    </ng-container>


                    <!-- Actions Column -->
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef> Aktionen</th>
                        <td mat-cell *matCellDef="let element">
                            <button class="btn-icon" matTooltip="Ad bearbeiten"
                                    (click)="editDialog(element)">
                                <mat-icon class="phx-cta" fontSet="material-symbols-outlined" aria-hidden="false">edit
                                </mat-icon>
                            </button>
                            <button class="btn-icon"
                                    matTooltip="Ad entfernen" (click)="deleteDialog(element)">
                                <mat-icon class="phx-cta" fontSet="material-symbols-outlined" aria-hidden="false">
                                    delete
                                </mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsSlides"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsSlides;" matRipple></tr>
                </table>
                <div class="d-flex justify-content-end my-m">
                    <mat-paginator
                            [length]="totalElements()"
                            [pageSize]="size()"
                            [pageIndex]="page()"
                            [pageSizeOptions]="[5, 10, 20, 50, 100]"
                            (page)="handlePageEvent($event)"
                            showFirstLastButtons>
                    </mat-paginator>
                </div>

            </div>
        }

    </div>
</div>